__turbopack_context__.v({
  "cardLink": "campaignbanner-module-scss-module__lJxf2a__cardLink",
  "containerStyles": "campaignbanner-module-scss-module__lJxf2a__containerStyles",
  "copyrightTextStyles": "campaignbanner-module-scss-module__lJxf2a__copyrightTextStyles",
  "ctaSectionWrapper": "campaignbanner-module-scss-module__lJxf2a__ctaSectionWrapper",
  "imageContainer": "campaignbanner-module-scss-module__lJxf2a__imageContainer",
  "imageContainerLeft": "campaignbanner-module-scss-module__lJxf2a__imageContainerLeft",
  "imageContainerRight": "campaignbanner-module-scss-module__lJxf2a__imageContainerRight",
  "largeHeadlineStyles": "campaignbanner-module-scss-module__lJxf2a__largeHeadlineStyles",
  "linkTextColorDark": "campaignbanner-module-scss-module__lJxf2a__linkTextColorDark",
  "linkTextColorLight": "campaignbanner-module-scss-module__lJxf2a__linkTextColorLight",
  "linkTextStyles": "campaignbanner-module-scss-module__lJxf2a__linkTextStyles",
  "smallHeadlineStyles": "campaignbanner-module-scss-module__lJxf2a__smallHeadlineStyles",
  "subHeadlineStyles": "campaignbanner-module-scss-module__lJxf2a__subHeadlineStyles",
  "textContainer": "campaignbanner-module-scss-module__lJxf2a__textContainer",
  "textContainerLeft": "campaignbanner-module-scss-module__lJxf2a__textContainerLeft",
  "wrapperStyles": "campaignbanner-module-scss-module__lJxf2a__wrapperStyles",
});
